<template>
  <el-container>
    <el-aside></el-aside>
    <el-container direction="vertical">
      <el-header>
        <div class="tools">
          <i @click.prevent="collapse" class="fa fa-align-justify"></i> 地理信息导航及资源共享平台
          <div style="float: right">
            <el-link href="http://www.zgeo.work/" target="_blank" type="success">站点主页</el-link>
            <el-link href="http://www.zgeo.work/share/#/commercial" target="_blank" type="success">资源下载</el-link>
            <el-link href="http://www.zgeo.work/mapbox/" target="_blank" type="primary">数字地理框架</el-link>
            <!-- <el-link href="http://zgeo.work:8999/public/drawDesk#/" target="_blank" type="primary">数字标绘平台</el-link> -->
            <el-link href="http://www.zgeo.work/mapbox/tools/index.html" target="_blank" type="danger">开发工具</el-link>
            <el-link href="http://zgeo.work/donate.html" target="_blank" type="warning">捐赠</el-link>
            <el-link style="margin-top: 10px;"
                     href="//shang.qq.com/wpa/qunwpa?idkey=af4460f98fabc653b538cd6765ea7af515eb1720303a7f344fba97c3054acc78"
                     target="_blank" type="success"><img border="0" src="//pub.idqqimg.com/wpa/images/group.png"
                                                         alt="ZGEO 数字地理框架" title="ZGEO 数字地理框架"></el-link>

          </div>
        </div>
      </el-header>
      <el-main>Main</el-main>
    </el-container>
  </el-container>

</template>

<script>
  import slider from "./slider.vue"
  import Main from "./Main.vue"

  import trans from '../transform/trans'

  export default {
    name: 'app',
    data: function () {
      return {
        collapsed: false
      }
    },
    components: {
      "el-aside": slider,
      "el-main": Main
    }, methods: {
      collapse: function () {
        this.collapsed = !this.collapsed;
        trans.$emit('collapse-slider', this.collapsed)
      },
      click(){
        this.$router.push({path:'/commercial'})
      }
    }
  }
</script>
<style>
  .el-header {
    background-color: #001f3f;
    color: #fff;
    text-align: left;
    line-height: 60px;
    font-size: 1.5em;
  }

  .el-container {
    height: 100%;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/components/Container.vue